import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
import { WoundSection } from './components/WoundSection';
import { NumbersSection } from './components/NumbersSection';
import { AuthorSection } from './components/AuthorSection';
import { MechanismSection } from './components/MechanismSection';
import { NinetyDayMap } from './components/NinetyDayMap';
import { ChapterFiveSection } from './components/ChapterFiveSection';
import { MidPageCTA } from './components/MidPageCTA';
import { ValueStack } from './components/ValueStack';
import { PriceReveal } from './components/PriceReveal';
import { GuaranteeSection } from './components/GuaranteeSection';
import { RealResults } from './components/RealResults';
import { IsThisForYou } from './components/IsThisForYou';
import { FAQSection } from './components/FAQSection';
import { UrgencyClose } from './components/UrgencyClose';
import { FinalCTABanner } from './components/FinalCTABanner';
import { CloserSection } from './components/CloserSection';
import { FooterSection } from './components/FooterSection';
import { StickyBottomBar } from './components/StickyBottomBar';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-primary-dark font-sans text-cream-light overflow-x-hidden relative" data-id="element-0">
      <UrgencyBanner data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WoundSection data-id="element-4" />
        <NumbersSection data-id="element-5" />
        <AuthorSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <NinetyDayMap data-id="element-8" />
        <ChapterFiveSection data-id="element-9" />
        <MidPageCTA data-id="element-10" />
        <ValueStack data-id="element-11" />
        <PriceReveal data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <RealResults data-id="element-14" />
        <IsThisForYou data-id="element-15" />
        <FAQSection data-id="element-16" />
        <UrgencyClose data-id="element-17" />
        <FinalCTABanner data-id="element-18" />
        <CloserSection data-id="element-19" />
      </main>

      <FooterSection data-id="element-20" />
      <StickyBottomBar data-id="element-21" />
    </div>;
}